import {IBannerData} from "OK/banners/bannerNew/data/BannerDataNull";

export class BannerDataIframeNull implements IBannerData {
    static IFRAME_NULL: BannerDataIframeNull = new BannerDataIframeNull();
}